export default __webpack_public_path__ + "static/Batenburg-80018e152e42e70ac2f38cb9bb42a8e2.jpeg";